import ForestOwnerName from "./ForestOwnerName";
import ForestOwnerLink from "./ForestOwnerLink";

import AddressDetail from "../../../../address/components/address/AddressDetail/AddressDetail";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ForestOwnerDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="ForestOwner-detail-title"
                    >
                        { label || t`Forest Owner` }: <ForestOwnerName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="ForestOwner-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="ForestOwner-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } data-testid="name-label" sx={{ textAlign: "left" }}><Trans>Name</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="name-value" sx={{ textAlign: "left" }}>{ data.name || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="description-label" sx={{ textAlign: "left" }}><Trans>Description</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="description-value" sx={{ textAlign: "left" }}>{ data.description || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="vatId-label" sx={{ textAlign: "left" }}><Trans>Vat Id</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="vatId-value" sx={{ textAlign: "left" }}>{ data.vatId || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="iban-label" sx={{ textAlign: "left" }}><Trans>Iban</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="iban-value" sx={{ textAlign: "left" }}>{ data.iban || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="bank-label" sx={{ textAlign: "left" }}><Trans>Bank</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="bank-value" sx={{ textAlign: "left" }}>{ data.bank || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="swift-label" sx={{ textAlign: "left" }}><Trans>Swift</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="swift-value" sx={{ textAlign: "left" }}>{ data.swift || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 12} } data-testid="addressId-label" sx={{ textAlign: "left" }}>
                        <Card>
                            <CardHeader subheader={t`Address`}/>
                            <CardContent>
                                <AddressDetail showTitle={false} 
                                                               data={ data.addressIdAddress } />
                            </CardContent>
                        </Card>
                    </Grid>
                    
            </Grid>
        </Stack>
    )
}

export default ForestOwnerDetail;
